import {
  SEASONAL_STATES,
  LOCALIZATION_MAP,
  TIMEZONES,
  LOCALIZATION,
  VIP_CODE,
} from '../../utils/constants'

import theme from '../../utils/styles/theme'

const { vip, bfcmCore, bfcmLastChance, bau } = SEASONAL_STATES
const { US, CA, UK, AU } = LOCALIZATION_MAP

const localizedDateMap = {
  [US]: '05/7',
  [CA]: '05/10',
  [UK]: '01/12',
  [AU]: '12/01',
}

export const SEASONAL_PDP_BANNER_CONSTANTS = {
  [vip]: {
    promoHeader: 'VIP Early Access:',
    promoSubHeader: {
      preStyledText: `Save on Calendar with Code ${VIP_CODE}`,
      styledText: '',
      postStyledText: '',
      styledTextColor: theme.space,
    },
    disclaimerText1: 'Discount applies to 10" & 15" Calendars.',
    disclaimerText2: 'Ends 4/25 at 11:59pm PST or while supplies last.',
    discountTextColor: theme.space,
    promoBannerBkgdColor: '#D5B6EC',
  },
  [bfcmCore]: {
    promoHeader: 'Mother’s Day Sale:',
    promoSubHeader: {
      preStyledText: 'Save On Top-Rated',
      styledText: '',
      postStyledText: '',
      styledTextColor: theme.space,
    },
    disclaimerText1: 'Discount automatically applied at checkout.',
    disclaimerText2: `Ends ${localizedDateMap[LOCALIZATION]} at 11:59pm ${TIMEZONES[LOCALIZATION]} or while supplies last.`,
    discountTextColor: theme.space,
    promoBannerBkgdColor: '#D5B6EC',
  },
  [bfcmLastChance]: {
    promoHeader: 'Final Hours:',
    promoSubHeader: {
      preStyledText: 'Save On Top-Rated',
      styledText: '',
      postStyledText: '',
      styledTextColor: theme.space,
    },
    disclaimerText1: 'Discount automatically applied at checkout.',
    disclaimerText2: `Ends ${localizedDateMap[LOCALIZATION]} at 11:59pm ${TIMEZONES[LOCALIZATION]} or while supplies last.`,
    discountTextColor: theme.space,
    promoBannerBkgdColor: '#D5B6EC',
  },
  [bau]: {
    promoHeader: 'VIP Early Access:',
    promoSubHeader: {
      preStyledText: `Save on Frame with Code ${VIP_CODE}`,
      styledText: '',
      postStyledText: '',
      styledTextColor: theme.space,
    },
    disclaimerText1: 'Ends 4/25 at 11:59pm PST or while supplies last.',
    discountTextColor: theme.space,
    promoBannerBkgdColor: '#D5B6EC',
  },
}

export const SEASONAL_PRODUCT_STATES = {
  ...SEASONAL_PDP_BANNER_CONSTANTS,

  prices: {
    [US]: {
      10: {
        bubble: '$30 OFF',
        discount: '$30',
        regularPrice: '169.99',
        discountedPrice: '139.99',
        discountWithPlus: '$20',
        discountedPriceWithPlus: '119.99',
      },
      15: {
        bubble: '$40 OFF',
        discount: '$40',
        regularPrice: '299.99',
        discountedPrice: '259.99',
        discountWithPlus: '$40',
        discountedPriceWithPlus: '239.99',
      },
      '15SB': {
        bubble: '$40 OFF',
        discount: '$40',
        regularPrice: '319.99',
        discountedPrice: '279.99',
        discountWithPlus: '$40',
        discountedPriceWithPlus: '259.99',
      },
      27: {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '599.99',
        discountedPrice: '499.99',
        discountWithPlus: '$130',
        discountedPriceWithPlus: '469.99',
      },
      '27SB': {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '629.99',
        discountedPrice: '529.99',
        discountWithPlus: '$130',
        discountedPriceWithPlus: '499.99',
      },
    },
    [CA]: {
      15: {
        bubble: '$60 OFF',
        discount: '$60',
        regularPrice: '449',
        discountedPrice: '389',
        discountWithPlus: '$20',
        discountedPriceWithPlus: '369',
      },
      27: {
        bubble: '$90 OFF',
        discount: '$90',
        regularPrice: '859',
        discountedPrice: '769',
        discountWithPlus: '$174',
        discountedPriceWithPlus: '724',
      },
    },
    [UK]: {
      15: {
        bubble: '£50 OFF',
        discount: '£50',
        regularPrice: '290',
        discountedPrice: '240',
        discountWithPlus: '£65',
        discountedPriceWithPlus: '225',
      },
      27: {
        bubble: '£80 OFF',
        discount: '£80',
        regularPrice: '550',
        discountedPrice: '470.00',
        discountWithPlus: '£105',
        discountedPriceWithPlus: '445.00',
      },
    },
    [AU]: {
      15: {
        bubble: '$100 OFF',
        discount: '$100',
        regularPrice: '529',
        discountedPrice: '429',
        discountWithPlus: '$120',
        discountedPriceWithPlus: '409',
      },
      27: {
        bubble: '$150 OFF',
        discount: '$150',
        regularPrice: '1199',
        discountedPrice: '1049',
        discountWithPlus: '$220',
        discountedPriceWithPlus: '979',
      },
    },
  },
}
